export default "__VITE_ASSET__e0Gp1bKT__"